import { ChatPanel } from "@components/chat/ChatOverlay";
import { useChatContext } from "@lib/hooks/useChatContext";
import { useChatStore } from "@lib/stores/chatStore";
import type { Organisation, User } from "@lib/types";
import type { ReactNode } from "react";
import type { Impersonation } from "@/App";
import { CurrentUserProvider } from "@/contexts/CurrentUserContext";
import { CurrentUserGoogleIntegrationProvider } from "@/contexts/CurrentUserGoogleIntegrationContext";
import { ComplianceIndicator } from "./ComplianceIndicator";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { SuperuserBanner } from "./SuperuserBanner";
import { TopBar } from "./TopBar";

interface AppShellProps {
  children: ReactNode;
  currentUser: User;
  currentOrganisation: Organisation | null;
  impersonation: Impersonation | null;
}

export function AppShell({
  children,
  currentUser,
  currentOrganisation,
  impersonation,
}: AppShellProps) {
  const chatOpen = useChatStore((s) => s.isOpen);

  // Keep chat context in sync with current route
  useChatContext();

  return (
    <CurrentUserProvider>
      <CurrentUserGoogleIntegrationProvider>
        <div className="flex h-screen flex-col bg-surface">
          {impersonation && <ImpersonationBanner {...impersonation} />}
          <SuperuserBanner />
          <ComplianceIndicator currentUser={currentUser} />
          <TopBar currentUser={currentUser} currentOrganisation={currentOrganisation} />
          <div className="flex flex-1 min-h-0">
            <main className="flex-1 overflow-y-auto p-6">{children}</main>
            {chatOpen && <ChatPanel />}
          </div>
        </div>
      </CurrentUserGoogleIntegrationProvider>
    </CurrentUserProvider>
  );
}
